// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin {
  font-size: 16px;

  .pricing-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    font-family: 'Noto Sans JP', sans-serif;
    padding: 3.375rem 5%;
  }
  
  /* デフォルト（PC）ではPlanCardもPlanCardBulkも2カラム */
  .plan-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 2rem;
  }


  .plan-container.single {
    grid-template-columns: 1fr; /* カードが1つの場合は1カラム */
    justify-items: center; /* カードを左右中央に配置 */
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  /* モバイル用メディアクエリ */
  @media (max-width: 767px) {
    .plan-container {
      gap: 0.5rem;
    }
    .plan-card-container {
      grid-template-columns: repeat(2, 1fr); /* PlanCardはモバイルでも2カラム */
    }

    .plan-card-bulk-container {
      grid-template-columns: 1fr; /* PlanCardBulkはモバイルでは1カラム */
    }
    .plan-card  {
      min-width: 100% !important; /* PlanCardの幅を100%に */
    }
    .plan-description {
      font-size: 0.8rem;
    }
    .plan-feature {
      font-size: 1rem;
    }
  }


  @media (min-width: 768px) {
    .pricing-section {
      padding: 3.375rem 10%; /* 54px -> 3.375rem, 30px -> 10% */
    }
  }
  
  @media (min-width: 980px) {
    .pricing-section {
      padding: 3.375rem 20%; /* 54px -> 3.375rem, 80px -> 20% */
    }
  }
  
  
  .plan-detail {
    padding: 1.25rem; /* 20px -> 1.25rem */
  }
  
 
 .plan-card {
    border: 0.1875rem solid;
    border-image: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8) 1;
    display: flex;
    flex-direction: column;
    min-width: 50%;
    text-align: center;
    transition: all 0.3s ease; /* スムーズに表示されるように */
  }
 
  
  .plan-header {
    background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);
    color: #fff;
    padding: 0.625rem; /* 10px -> 0.625rem */
    font-weight: 700;
  }
  
  
  .plan-title {
    margin: 0;
    font-size: 1.6rem; /* 必要に応じてフォントサイズを調整 */
    font-family: serif;
    color: #fff !important; /* フォントカラーを強制適用 */
    font-weight: bold !important; /* フォントの太さを強制適用 */
  }
  
  .plan-description {
    margin: 0.625rem 0; /* 10px -> 0.625rem */
    font-size: 1.4rem;
  }
  
  .price-container {
    margin-top: 0.625rem; /* 10px -> 0.625rem */
    text-align: center;
  }
  
  .price-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap: 0.375rem; /* 6px -> 0.375rem */
  }
  
  .price {
    color: #ff9b15;
    font-size: 2.4rem; /* 24px -> 1.5rem */
    font-weight: bold !important; 
    line-height: 1;
    font-family: serif;
  }
 
  .price-label, .price-currency {
    font-size: 1.2rem;
    line-height: 1.2; /* フォントサイズに合った行の高さを指定 */
    vertical-align: baseline; /* priceと基線を揃える */
    font-family: serif;
  }

  .discount-label {
    margin-top: 0.625rem; /* 10px -> 0.625rem */
    font-size: 1.2rem; /* 14px -> 0.875rem */
  }
  
  .discount-highlight {
    display: inline;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, #ff6 40%);
    padding: 0 0.125rem; /* 2px -> 0.125rem */
  }
  
  .plan-feature {
    margin-top: 0.625rem; /* 10px -> 0.625rem */
    color: #2a3d86;
    font-weight: 700;
    font-size: 1.4rem;
  }
  
  .pricing-notes {
    width: 100%;
    max-width: 67.5rem; /* 1080px -> 67.5rem */
    text-align: left;
    margin-top: 1.25rem; /* 20px -> 1.25rem */
  }
 
  .price-wrapper.original-price {
    font-size: 1.4rem !important; /* 必ず適用するために !important を追加 */
    color: #555 !important; /* 同様に !important を追加 */
    position: relative; /* 取り消し線のために必要 */
  }
  
  .price-wrapper.original-price .price-label,
  .price-wrapper.original-price .price,
  .price-wrapper.original-price .price-currency {
    display: inline-block;
    position: relative;
    font-size: inherit; /* 親要素のフォントサイズを継承 */
    color: inherit; /* 親要素の文字色を継承 */
  }


  .price-wrapper.original-price .price-label,
  .price-wrapper.original-price .price-currency {
    font-size: 1rem; /* ラベルのフォントサイズを調整 */
    color: #555; /* 中間色 */
  }

  .price-wrapper.original-price .price-group {
    display: inline-flex; /* ラベル、金額、通貨をグループ化 */
    align-items: baseline; /* 基線に揃える */
    position: relative;
  }
  
  .price-wrapper.original-price .price-group::after {
    content: '';
    position: absolute;
    top: 50%; /* テキストの中央を通る */
    left: 0;
    right: 0; /* グループ内の幅全体 */
    height: 0.2rem;
    background: #e63946;
    transform: rotate(-10deg); /* 左下から右上に斜めに表示 */
    z-index: 1;
    clip-path: polygon(0 50%, 5% 0, 95% 0, 100% 50%, 95% 100%, 5% 100%); /* 両端を尖らせる */
  }

  
  .price-wrapper.discount-price .price-label {
    font-size: 1rem; /* ラベルのフォントサイズを調整 */
    color: #555; /* 中間色 */
  }
  
  .price-wrapper.discount-price .price {
    font-size: 2.4rem; /* 割引価格を強調 */
    color: #e63946; /* 赤色 */
    font-weight: bold; /* 太字 */
  }
  
  .price-wrapper.discount-price .price-currency {
    font-size: 1rem;
    color: #555;
  }


  .notes-text {
    font-size: 1.2rem; /* 16px -> 1rem */
    color: #666;
  }
  
  .additional-info {
    margin-top: 1.25rem; /* 20px -> 1.25rem */
    font-size: 0.9375rem; /* 15px -> 0.9375rem */
    color: #2a3d86;
    font-weight: 700;
  }
  
  .info-list {
    list-style-type: none;
    padding-left: 0;
  }
  
  .info-item {
    position: relative;
    padding-left: 2.1875rem; /* 35px -> 2.1875rem */
    margin-bottom: 0.625rem; /* 10px -> 0.625rem */
    font-size: 1.4rem; 
  }
  
  .info-border {
    border: 0.125rem solid rgba(42, 61, 134, 0.5); /* 2px -> 0.125rem */
    position: absolute;
    left: 0;
    top: 0.3125rem; /* 5px -> 0.3125rem */
    width: 1.25rem; /* 20px -> 1.25rem */
    height: 1.25rem; /* 20px -> 1.25rem */
    border-radius: 50%;
  }
  
  .info-overlay {
    background-color: rgba(42, 61, 134, 0.3);
    position: absolute;
    left: 0.3125rem; /* 5px -> 0.3125rem */
    top: 0.3125rem; /* 5px -> 0.3125rem */
    width: 0.625rem; /* 10px -> 0.625rem */
    height: 0.625rem; /* 10px -> 0.625rem */
    border-radius: 50%;
  }
  
  .plan-details {
    display: flex;
    flex-direction: column;
    margin-top: 0.625rem; /* 10px -> 0.625rem */
    gap: 0.25rem; /* 4px -> 0.25rem */
  }
  
  .plan-detail-item {
    display: flex;
    justify-content: flex-start; /* テキストを左詰に */
    align-items: flex-start; /* 上に揃えて表示 */
    font-size: 1.2rem; /* 14px -> 0.875rem */
    line-height: 1.5;
  }
  
  .plan-detail-item .label {
    text-align: left;
    padding-right: 0.5rem; /* 4px -> 0.5rem */
    white-space: nowrap; /* 改行を防止 */
    flex-shrink: 0; /* ラベルが縮まらないように */
  }
  
  .plan-detail-item .value {
    text-align: left;
    flex-grow: 1; /* Valueが余白に応じて広がる */
    word-wrap: break-word; /* 単語の途中で改行 */
    white-space: pre-wrap; /* 改行を維持しつつ、自動的に折り返し */
    padding-left: 0; /* 左側に余白を設けない */
    overflow-wrap: break-word; /* 長い単語を折り返す */
  }
  
  .plan-detail-item .value::before {
    content: ''; /* 改行時にラベルの位置に影響されないよう調整 */
    display: block;
    margin-left: calc(0.5rem + 1px); /* ラベルと値の間に余白を追加 */
    height: 0;
  }

  .contact-link {
    color: #2a3d86; /* リンクの色 */
    text-decoration: underline; /* 下線を引く */
  }
  
  .contact-link:hover {
    color: #4a5db6; /* リンクのホバー時の色 */
  }

  .box27 {
    position: relative;
    margin: 2em 0;
    padding: 0.5em 0.5em;
    border: solid 0.11rem #7a9fd8;
  }

  .box27 .box-title {
    position: absolute;
    top: 0; /* ボーダーのすぐ上に配置 */
    left: -0.11rem; /* ボーダー幅の分だけ左にずらす */
    transform: translateY(-100%); /* 上方向に移動してボーダーにピッタリくっつける */
    padding: 0 1em;
    height: 25px;
    line-height: 25px;
    font-size: 1.2rem;
    background: #7a9fd8;
    color: #ffffff;
    border-radius: 0.25rem 0.25rem 0 0;
  }


  
  .categories-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 1.5rem;
    font-size: 1.4rem;
  }
  
  @media (max-width: 767px) {
    .categories-container {
      justify-content: flex-start;
    }
  }
  
  .category-item {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.4rem;
    color: #2a3d86;
    font-family: serif;
    font-style: italic;
  }
  
  .category-icon {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/PriceTableSelector.css"],"names":[],"mappings":"AAAA;EACE,eAAe;;EAEf;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,uCAAuC;IACvC,oBAAoB;EACtB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;;;EAGA;IACE,0BAA0B,EAAE,mBAAmB;IAC/C,qBAAqB,EAAE,gBAAgB;IACvC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE;MACE,WAAW;IACb;IACA;MACE,qCAAqC,EAAE,wBAAwB;IACjE;;IAEA;MACE,0BAA0B,EAAE,4BAA4B;IAC1D;IACA;MACE,0BAA0B,EAAE,qBAAqB;IACnD;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;EACF;;;EAGA;IACE;MACE,qBAAqB,EAAE,kCAAkC;IAC3D;EACF;;EAEA;IACE;MACE,qBAAqB,EAAE,kCAAkC;IAC3D;EACF;;;EAGA;IACE,gBAAgB,EAAE,oBAAoB;EACxC;;;CAGD;IACG,uBAAuB;IACvB,iEAAiE;IACjE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,yBAAyB,EAAE,kBAAkB;EAC/C;;;EAGA;IACE,6DAA6D;IAC7D,WAAW;IACX,iBAAiB,EAAE,qBAAqB;IACxC,gBAAgB;EAClB;;;EAGA;IACE,SAAS;IACT,iBAAiB,EAAE,qBAAqB;IACxC,kBAAkB;IAClB,sBAAsB,EAAE,iBAAiB;IACzC,4BAA4B,EAAE,iBAAiB;EACjD;;EAEA;IACE,kBAAkB,EAAE,qBAAqB;IACzC,iBAAiB;EACnB;;EAEA;IACE,oBAAoB,EAAE,qBAAqB;IAC3C,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,aAAa,EAAE,oBAAoB;EACrC;;EAEA;IACE,cAAc;IACd,iBAAiB,EAAE,mBAAmB;IACtC,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB,EAAE,uBAAuB;IACzC,wBAAwB,EAAE,iBAAiB;IAC3C,kBAAkB;EACpB;;EAEA;IACE,oBAAoB,EAAE,qBAAqB;IAC3C,iBAAiB,EAAE,qBAAqB;EAC1C;;EAEA;IACE,eAAe;IACf,mEAAmE;IACnE,mBAAmB,EAAE,oBAAoB;EAC3C;;EAEA;IACE,oBAAoB,EAAE,qBAAqB;IAC3C,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB,EAAE,sBAAsB;IAC1C,gBAAgB;IAChB,mBAAmB,EAAE,oBAAoB;EAC3C;;EAEA;IACE,4BAA4B,EAAE,6BAA6B;IAC3D,sBAAsB,EAAE,uBAAuB;IAC/C,kBAAkB,EAAE,gBAAgB;EACtC;;EAEA;;;IAGE,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB,EAAE,mBAAmB;IACvC,cAAc,EAAE,eAAe;EACjC;;;EAGA;;IAEE,eAAe,EAAE,mBAAmB;IACpC,WAAW,EAAE,QAAQ;EACvB;;EAEA;IACE,oBAAoB,EAAE,oBAAoB;IAC1C,qBAAqB,EAAE,WAAW;IAClC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ,EAAE,eAAe;IACzB,OAAO;IACP,QAAQ,EAAE,cAAc;IACxB,cAAc;IACd,mBAAmB;IACnB,yBAAyB,EAAE,iBAAiB;IAC5C,UAAU;IACV,mEAAmE,EAAE,YAAY;EACnF;;;EAGA;IACE,eAAe,EAAE,mBAAmB;IACpC,WAAW,EAAE,QAAQ;EACvB;;EAEA;IACE,iBAAiB,EAAE,YAAY;IAC/B,cAAc,EAAE,OAAO;IACvB,iBAAiB,EAAE,OAAO;EAC5B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;;EAGA;IACE,iBAAiB,EAAE,iBAAiB;IACpC,WAAW;EACb;;EAEA;IACE,mBAAmB,EAAE,oBAAoB;IACzC,oBAAoB,EAAE,sBAAsB;IAC5C,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB,EAAE,sBAAsB;IAC/C,uBAAuB,EAAE,qBAAqB;IAC9C,iBAAiB;EACnB;;EAEA;IACE,6CAA6C,EAAE,oBAAoB;IACnE,kBAAkB;IAClB,OAAO;IACP,cAAc,EAAE,qBAAqB;IACrC,cAAc,EAAE,oBAAoB;IACpC,eAAe,EAAE,oBAAoB;IACrC,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;IACxC,kBAAkB;IAClB,eAAe,EAAE,qBAAqB;IACtC,cAAc,EAAE,qBAAqB;IACrC,eAAe,EAAE,qBAAqB;IACtC,gBAAgB,EAAE,qBAAqB;IACvC,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB,EAAE,qBAAqB;IAC3C,YAAY,EAAE,mBAAmB;EACnC;;EAEA;IACE,aAAa;IACb,2BAA2B,EAAE,aAAa;IAC1C,uBAAuB,EAAE,YAAY;IACrC,iBAAiB,EAAE,qBAAqB;IACxC,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB,EAAE,kBAAkB;IACzC,mBAAmB,EAAE,UAAU;IAC/B,cAAc,EAAE,iBAAiB;EACnC;;EAEA;IACE,gBAAgB;IAChB,YAAY,EAAE,oBAAoB;IAClC,qBAAqB,EAAE,aAAa;IACpC,qBAAqB,EAAE,sBAAsB;IAC7C,eAAe,EAAE,eAAe;IAChC,yBAAyB,EAAE,cAAc;EAC3C;;EAEA;IACE,WAAW,EAAE,0BAA0B;IACvC,cAAc;IACd,+BAA+B,EAAE,kBAAkB;IACnD,SAAS;EACX;;EAEA;IACE,cAAc,EAAE,UAAU;IAC1B,0BAA0B,EAAE,UAAU;EACxC;;EAEA;IACE,cAAc,EAAE,eAAe;EACjC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,MAAM,EAAE,gBAAgB;IACxB,cAAc,EAAE,mBAAmB;IACnC,4BAA4B,EAAE,2BAA2B;IACzD,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,kCAAkC;EACpC;;;;EAIA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE;MACE,2BAA2B;IAC7B;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;AACF","sourcesContent":[".elt-wp-plugin {\n  font-size: 16px;\n\n  .pricing-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #fff;\n    font-family: 'Noto Sans JP', sans-serif;\n    padding: 3.375rem 5%;\n  }\n  \n  /* デフォルト（PC）ではPlanCardもPlanCardBulkも2カラム */\n  .plan-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 2rem;\n    max-width: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    margin-bottom: 2rem;\n  }\n\n\n  .plan-container.single {\n    grid-template-columns: 1fr; /* カードが1つの場合は1カラム */\n    justify-items: center; /* カードを左右中央に配置 */\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  /* モバイル用メディアクエリ */\n  @media (max-width: 767px) {\n    .plan-container {\n      gap: 0.5rem;\n    }\n    .plan-card-container {\n      grid-template-columns: repeat(2, 1fr); /* PlanCardはモバイルでも2カラム */\n    }\n\n    .plan-card-bulk-container {\n      grid-template-columns: 1fr; /* PlanCardBulkはモバイルでは1カラム */\n    }\n    .plan-card  {\n      min-width: 100% !important; /* PlanCardの幅を100%に */\n    }\n    .plan-description {\n      font-size: 0.8rem;\n    }\n    .plan-feature {\n      font-size: 1rem;\n    }\n  }\n\n\n  @media (min-width: 768px) {\n    .pricing-section {\n      padding: 3.375rem 10%; /* 54px -> 3.375rem, 30px -> 10% */\n    }\n  }\n  \n  @media (min-width: 980px) {\n    .pricing-section {\n      padding: 3.375rem 20%; /* 54px -> 3.375rem, 80px -> 20% */\n    }\n  }\n  \n  \n  .plan-detail {\n    padding: 1.25rem; /* 20px -> 1.25rem */\n  }\n  \n \n .plan-card {\n    border: 0.1875rem solid;\n    border-image: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8) 1;\n    display: flex;\n    flex-direction: column;\n    min-width: 50%;\n    text-align: center;\n    transition: all 0.3s ease; /* スムーズに表示されるように */\n  }\n \n  \n  .plan-header {\n    background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);\n    color: #fff;\n    padding: 0.625rem; /* 10px -> 0.625rem */\n    font-weight: 700;\n  }\n  \n  \n  .plan-title {\n    margin: 0;\n    font-size: 1.6rem; /* 必要に応じてフォントサイズを調整 */\n    font-family: serif;\n    color: #fff !important; /* フォントカラーを強制適用 */\n    font-weight: bold !important; /* フォントの太さを強制適用 */\n  }\n  \n  .plan-description {\n    margin: 0.625rem 0; /* 10px -> 0.625rem */\n    font-size: 1.4rem;\n  }\n  \n  .price-container {\n    margin-top: 0.625rem; /* 10px -> 0.625rem */\n    text-align: center;\n  }\n  \n  .price-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    gap: 0.375rem; /* 6px -> 0.375rem */\n  }\n  \n  .price {\n    color: #ff9b15;\n    font-size: 2.4rem; /* 24px -> 1.5rem */\n    font-weight: bold !important; \n    line-height: 1;\n    font-family: serif;\n  }\n \n  .price-label, .price-currency {\n    font-size: 1.2rem;\n    line-height: 1.2; /* フォントサイズに合った行の高さを指定 */\n    vertical-align: baseline; /* priceと基線を揃える */\n    font-family: serif;\n  }\n\n  .discount-label {\n    margin-top: 0.625rem; /* 10px -> 0.625rem */\n    font-size: 1.2rem; /* 14px -> 0.875rem */\n  }\n  \n  .discount-highlight {\n    display: inline;\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, #ff6 40%);\n    padding: 0 0.125rem; /* 2px -> 0.125rem */\n  }\n  \n  .plan-feature {\n    margin-top: 0.625rem; /* 10px -> 0.625rem */\n    color: #2a3d86;\n    font-weight: 700;\n    font-size: 1.4rem;\n  }\n  \n  .pricing-notes {\n    width: 100%;\n    max-width: 67.5rem; /* 1080px -> 67.5rem */\n    text-align: left;\n    margin-top: 1.25rem; /* 20px -> 1.25rem */\n  }\n \n  .price-wrapper.original-price {\n    font-size: 1.4rem !important; /* 必ず適用するために !important を追加 */\n    color: #555 !important; /* 同様に !important を追加 */\n    position: relative; /* 取り消し線のために必要 */\n  }\n  \n  .price-wrapper.original-price .price-label,\n  .price-wrapper.original-price .price,\n  .price-wrapper.original-price .price-currency {\n    display: inline-block;\n    position: relative;\n    font-size: inherit; /* 親要素のフォントサイズを継承 */\n    color: inherit; /* 親要素の文字色を継承 */\n  }\n\n\n  .price-wrapper.original-price .price-label,\n  .price-wrapper.original-price .price-currency {\n    font-size: 1rem; /* ラベルのフォントサイズを調整 */\n    color: #555; /* 中間色 */\n  }\n\n  .price-wrapper.original-price .price-group {\n    display: inline-flex; /* ラベル、金額、通貨をグループ化 */\n    align-items: baseline; /* 基線に揃える */\n    position: relative;\n  }\n  \n  .price-wrapper.original-price .price-group::after {\n    content: '';\n    position: absolute;\n    top: 50%; /* テキストの中央を通る */\n    left: 0;\n    right: 0; /* グループ内の幅全体 */\n    height: 0.2rem;\n    background: #e63946;\n    transform: rotate(-10deg); /* 左下から右上に斜めに表示 */\n    z-index: 1;\n    clip-path: polygon(0 50%, 5% 0, 95% 0, 100% 50%, 95% 100%, 5% 100%); /* 両端を尖らせる */\n  }\n\n  \n  .price-wrapper.discount-price .price-label {\n    font-size: 1rem; /* ラベルのフォントサイズを調整 */\n    color: #555; /* 中間色 */\n  }\n  \n  .price-wrapper.discount-price .price {\n    font-size: 2.4rem; /* 割引価格を強調 */\n    color: #e63946; /* 赤色 */\n    font-weight: bold; /* 太字 */\n  }\n  \n  .price-wrapper.discount-price .price-currency {\n    font-size: 1rem;\n    color: #555;\n  }\n\n\n  .notes-text {\n    font-size: 1.2rem; /* 16px -> 1rem */\n    color: #666;\n  }\n  \n  .additional-info {\n    margin-top: 1.25rem; /* 20px -> 1.25rem */\n    font-size: 0.9375rem; /* 15px -> 0.9375rem */\n    color: #2a3d86;\n    font-weight: 700;\n  }\n  \n  .info-list {\n    list-style-type: none;\n    padding-left: 0;\n  }\n  \n  .info-item {\n    position: relative;\n    padding-left: 2.1875rem; /* 35px -> 2.1875rem */\n    margin-bottom: 0.625rem; /* 10px -> 0.625rem */\n    font-size: 1.4rem; \n  }\n  \n  .info-border {\n    border: 0.125rem solid rgba(42, 61, 134, 0.5); /* 2px -> 0.125rem */\n    position: absolute;\n    left: 0;\n    top: 0.3125rem; /* 5px -> 0.3125rem */\n    width: 1.25rem; /* 20px -> 1.25rem */\n    height: 1.25rem; /* 20px -> 1.25rem */\n    border-radius: 50%;\n  }\n  \n  .info-overlay {\n    background-color: rgba(42, 61, 134, 0.3);\n    position: absolute;\n    left: 0.3125rem; /* 5px -> 0.3125rem */\n    top: 0.3125rem; /* 5px -> 0.3125rem */\n    width: 0.625rem; /* 10px -> 0.625rem */\n    height: 0.625rem; /* 10px -> 0.625rem */\n    border-radius: 50%;\n  }\n  \n  .plan-details {\n    display: flex;\n    flex-direction: column;\n    margin-top: 0.625rem; /* 10px -> 0.625rem */\n    gap: 0.25rem; /* 4px -> 0.25rem */\n  }\n  \n  .plan-detail-item {\n    display: flex;\n    justify-content: flex-start; /* テキストを左詰に */\n    align-items: flex-start; /* 上に揃えて表示 */\n    font-size: 1.2rem; /* 14px -> 0.875rem */\n    line-height: 1.5;\n  }\n  \n  .plan-detail-item .label {\n    text-align: left;\n    padding-right: 0.5rem; /* 4px -> 0.5rem */\n    white-space: nowrap; /* 改行を防止 */\n    flex-shrink: 0; /* ラベルが縮まらないように */\n  }\n  \n  .plan-detail-item .value {\n    text-align: left;\n    flex-grow: 1; /* Valueが余白に応じて広がる */\n    word-wrap: break-word; /* 単語の途中で改行 */\n    white-space: pre-wrap; /* 改行を維持しつつ、自動的に折り返し */\n    padding-left: 0; /* 左側に余白を設けない */\n    overflow-wrap: break-word; /* 長い単語を折り返す */\n  }\n  \n  .plan-detail-item .value::before {\n    content: ''; /* 改行時にラベルの位置に影響されないよう調整 */\n    display: block;\n    margin-left: calc(0.5rem + 1px); /* ラベルと値の間に余白を追加 */\n    height: 0;\n  }\n\n  .contact-link {\n    color: #2a3d86; /* リンクの色 */\n    text-decoration: underline; /* 下線を引く */\n  }\n  \n  .contact-link:hover {\n    color: #4a5db6; /* リンクのホバー時の色 */\n  }\n\n  .box27 {\n    position: relative;\n    margin: 2em 0;\n    padding: 0.5em 0.5em;\n    border: solid 0.11rem #7a9fd8;\n  }\n\n  .box27 .box-title {\n    position: absolute;\n    top: 0; /* ボーダーのすぐ上に配置 */\n    left: -0.11rem; /* ボーダー幅の分だけ左にずらす */\n    transform: translateY(-100%); /* 上方向に移動してボーダーにピッタリくっつける */\n    padding: 0 1em;\n    height: 25px;\n    line-height: 25px;\n    font-size: 1.2rem;\n    background: #7a9fd8;\n    color: #ffffff;\n    border-radius: 0.25rem 0.25rem 0 0;\n  }\n\n\n  \n  .categories-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n    font-size: 1.4rem;\n  }\n  \n  @media (max-width: 767px) {\n    .categories-container {\n      justify-content: flex-start;\n    }\n  }\n  \n  .category-item {\n    display: flex;\n    align-items: center;\n    margin-right: 1rem;\n    margin-bottom: 0.5rem;\n    font-size: 1.4rem;\n    color: #2a3d86;\n    font-family: serif;\n    font-style: italic;\n  }\n  \n  .category-icon {\n    width: 1rem;\n    height: 1rem;\n    margin-right: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
